'use client';

import { useState } from 'react';

const useMultiStepForm = (totalSteps: number) => {
    const [currentStep, setCurrentStep] = useState(0);

    const nextStep = () => setCurrentStep((s) => Math.min(s + 1, totalSteps - 1));
    const prevStep = () => setCurrentStep((s) => Math.max(s - 1, 0));
    const goToStep = (index: number) => setCurrentStep(index);

    return {
        currentStep,
        nextStep,
        prevStep,
        goToStep,
        isFirst: currentStep === 0,
        isLast: currentStep === totalSteps - 1
    };
};

export default useMultiStepForm;

